module.exports = __webpack_public_path__ + "static/media/ssec.201c7aa9.png";